import { anatomy as t } from "@chakra-ui/theme-tools";
const o = t("section").parts(
  "body",
  "button",
  "description",
  "icon",
  "iconButton",
  "title",
  "titleRow",
  "box"
).extend("section", "header", "footer"), n = t("subheader").parts("title", "container").extend("subheader");
t("odiCard").parts("top", "title", "description", "icon", "body", "closeButton").extend("card", "header", "footer");
t("dropdown").parts(
  "button",
  "divider",
  "DMenuButton",
  "DMenuList",
  "DMenuSubList",
  "DMenuBackButton",
  "DMenuItem"
);
export {
  o as sectionAnatomy,
  n as subHeaderAnatomy
};
